

import React, { memo } from 'react';
import cx from 'classnames';
import '../styles/divider.scss';







const Divider = ({
  className,
  isFullWidth,
  children
}) =>
<div
  className={cx('divider', className, {
    'divider--full-width': isFullWidth
  })}>

    {children && <span className="divider__content">{children}</span>}
  </div>;


export default memo(Divider);